import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-wrapper" }
const _hoisted_2 = { class: "search-form__destination" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "search-form__destination__title" }, "Маршрут", -1)
const _hoisted_4 = { class: "search-form__destination search-form__destination" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "search-form__destination__title" }, "Даты", -1)
const _hoisted_6 = { class: "search-form__destination" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "search-form__destination__title" }, "Время вылета", -1)
const _hoisted_8 = {
  key: 1,
  class: "route-buttons__wrapper"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_search_air_port = _resolveComponent("search-air-port")
  const _component_datepicker = _resolveComponent("datepicker")
  const _component_Dropdown = _resolveComponent("Dropdown")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("label", null, [
        _createVNode(_component_search_air_port, {
          onSelectData: _ctx.selectFrom,
          placeholder: "Откуда"
        }, null, 8, ["onSelectData"])
      ]),
      _createVNode("label", null, [
        _createVNode(_component_search_air_port, {
          onSelectData: _ctx.selectTo,
          placeholder: "Куда"
        }, null, 8, ["onSelectData"])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_datepicker, {
        placeholder: "Дата туда",
        "monday-first": true,
        onSelected: _ctx.setDataFrom,
        "wrapper-class": "vuejs3-datepicker__wrapper",
        class: {
          'vuejs3-datepicker__wrapper--one-way': _ctx.wayType !== 'two-ways'
        },
        "disabled-dates": _ctx.disabledDatesFrom
      }, null, 8, ["onSelected", "class", "disabled-dates"]),
      _withDirectives(_createVNode(_component_datepicker, {
        placeholder: "Дата от туда",
        "monday-first": true,
        "disabled-dates": _ctx.disabledDatesTo,
        onSelected: _ctx.setDataTo,
        "wrapper-class": "vuejs3-datepicker__wrapper vuejs3-datepicker__wrapper--right"
      }, null, 8, ["disabled-dates", "onSelected"]), [
        [_vShow, _ctx.wayType == 'two-ways']
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(_component_Dropdown, {
        modelValue: _ctx.hourFrom,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.hourFrom = $event)),
        options: _ctx.hours,
        class: "hours-dropdown",
        placeholder: _ctx.hourFrom
      }, null, 8, ["modelValue", "options", "placeholder"]),
      _createVNode(_component_Dropdown, {
        modelValue: _ctx.hourTill,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.hourTill = $event)),
        options: _ctx.hours,
        class: "hours-dropdown",
        placeholder: _ctx.hourTill
      }, null, 8, ["modelValue", "options", "placeholder"])
    ]),
    (_ctx.index == 0)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          type: "submit",
          class: "search-form__submit search-form__submit--avia",
          disabled: !_ctx.disabledSearch,
          onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.searchData(...args)), ["prevent"]))
        }, null, 8, ["disabled"]))
      : (_openBlock(), _createBlock("div", _hoisted_8, [
          (_ctx.wayType == 'complex-way')
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                href: "#",
                class: "search-form__delete search-form__add",
                onClick: _cache[4] || (_cache[4] = _withModifiers((...args) => (_ctx.addRoute(...args)), ["prevent"]))
              }))
            : _createCommentVNode("", true),
          (_ctx.index >= 2)
            ? (_openBlock(), _createBlock("button", {
                key: 1,
                class: "search-form__delete",
                onClick: _cache[5] || (_cache[5] = _withModifiers($event => (_ctx.deleteRoute(_ctx.index)), ["prevent"]))
              }))
            : _createCommentVNode("", true)
        ]))
  ]))
}